export const isPowerControlAvailableInDevices = (
  devices: SessionInventoryHardwareData[] | undefined,
): boolean => devices?.some((device) => device.powerControl === 'Yes') || false;
